import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: 'rgb(91, 59, 140)',
      light: 'rgb(131, 110, 170)'
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        input:-webkit-autofill {
          box-shadow: 0 0 0 1000px white inset !important;
          -webkit-text-fill-color: black !important;
        }
      `,
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '1rem',
          borderRadius: 30,
          backgroundColor: 'white',
          marginRight: '1rem',
          overflowX: 'auto',
          '&.Mui-selected': {
            color: 'white',
            fontWeight: 600,
            background: 'linear-gradient(to right, #4e2a84, #a495c3)',
          },
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffff'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          '&:hover': {
            backgroundColor: 'rgb(118, 093, 160)',
          },
        },
      },
    },
  },
  button: {
    contained: {
      bgOnHover: 'rgb(118, 093, 160)'

    },
  },
  typography: {
    fontFamily: "Lexend Deca",
    h6: { fontWeight: 400}
  },
});

  
export default customTheme;